import { render, staticRenderFns } from "./CorpProductManagement.vue?vue&type=template&id=6d867d48&scoped=true"
import script from "./CorpProductManagement.vue?vue&type=script&lang=js"
export * from "./CorpProductManagement.vue?vue&type=script&lang=js"
import style0 from "./CorpProductManagement.vue?vue&type=style&index=0&id=6d867d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d867d48",
  null
  
)

export default component.exports